import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private flags: { [key: string]: any };

  constructor() {
    this.initializeFlags();
  }

  private initializeFlags(): void {
    const rawFlags = environment.featureFlags;

    // Guard against null, undefined, or empty spaces
    if (!rawFlags || !rawFlags.trim()) {
      this.flags = {};
      return;
    }

    try {
      const parsed = JSON.parse(rawFlags);

      this.flags = (typeof parsed === 'object' && parsed !== null) ? parsed : {};
    } catch {
      this.flags = {}; // Secure fallback to block features instead of crashing app
    }
  }

  public isEnabled(key: string): boolean {
    return !!this.flags[key];
  }

  public isDTVCommercialBannerEnabled(): boolean {
    return this.isEnabled('isDTVCommercialBannerEnabled');
  }

  public isVoiceFlowEnabled(): boolean {
    return this.isEnabled('isVoiceFlowEnabled');
  }

  public isSMBFlowEnabled(): boolean {
    return this.isEnabled('isSMBFlowEnabled');
  }

  public isServiceLevelShippingEnabled() {
    return this.isEnabled('isServiceLevelShippingEnabled');
  }

  public isDTVCommercialPeacockBannerEnabled(): boolean {
    return this.isEnabled('isDTVCommercialPeacockBannerEnabled');
  }

  public isSeamlessNavigationEnabled(): boolean {
    return this.isEnabled('isSeamlessNavigationEnabled');
  }

  public isLICProcessEnabled(): boolean {
    return this.isEnabled('isLICProcessEnabled');
  }


  getAll(): { [key: string]: any } {
    return { ...this.flags };
  }
}
